/** Hungarian catalog. Keep sentences whole; parameters are values, not grammar. */
export const hu: Record<string, string> = {
  'research.area.physics': 'Fizika', 'research.area.society': 'Társadalom', 'research.area.engineering': 'Mérnöki',
  'research.theme.economy': 'gazdaság', 'research.theme.military': 'haditechnika', 'research.theme.exploration': 'felfedezés',
  'research.theme.diplomacy': 'diplomácia', 'research.theme.science': 'tudomány',

  'research.trait.gifted.name': 'Zseni', 'research.trait.gifted.blurb': 'A területe kutatási pontját 50%-kal jobban növeli.',
  'research.trait.expert.name': 'Szakértő', 'research.trait.expert.blurb': 'Egy részterületen a megfelelő kártyák gyakrabban kerülnek elő.',
  'research.trait.quick_learner.name': 'Gyors tanuló', 'research.trait.quick_learner.blurb': 'Másfélszer annyi tapasztalatot szerez.',
  'research.trait.frugal.name': 'Takarékos', 'research.trait.frugal.blurb': 'A fenntartása 40%-kal kisebb.',
  'research.trait.explorer.name': 'Felfedező', 'research.trait.explorer.blurb': 'A felmérésekből származó adat az ő területére kerül.',

  'research.species.human.name': 'Ember', 'research.species.vorr.name': 'Vorr', 'research.species.selu.name': 'Selu',
  'research.species.vorr.desc': 'Kitalált faj: kemény hangzású, törzsi nevek.', 'research.species.selu.desc': 'Kitalált faj: lágy, magánhangzó-gazdag nevek.',

  'research.error.disabled': 'A tudósok rendszere jelenleg ki van kapcsolva.',
  'research.error.not_found': 'A civilizáció nem található.',
  'research.error.offer_expired': 'Ez az ajánlat már lejárt: nézd meg az aktuális jelölteket.',
  'research.error.insufficient_resources': 'Nincs elég nyersanyag a felvételhez.',
  'research.error.capacity': 'Nincs szabad hely: több laborral több tudós tartható.',
  'research.error.unknown_scientist': 'Ismeretlen tudós.',
  'research.error.already_hired': 'Ezt a jelöltet már felvetted.',

  'research.log.hired': 'Felvetted: {name} ({area}, {level}. szint)',
  'research.log.retired': '{name} nyugdíjba vonult. Válassz utódot a jelöltek közül.',
  'research.log.levelUp': '{name} szintet lépett: {level}. szint',
  'research.log.dismissed': 'Elbocsátottad: {name}',
  'research.log.survey': 'Felmérési adat ({system}): +{rp} adat a(z) {area} kutatásba',

  'research.rp.leader': 'Vezető tudós: {name} (+{percent})',
  'research.rp.surveyData': 'Felmérési adat (egyszeri)',
  'research.rp.tip.home': 'Az anyabolygó tudósai', 'research.rp.tip.lab': 'A terület laborja', 'research.rp.tip.leader': 'A terület vezető tudósának bónusza',
  'research.rp.tip.tech': 'Technológiák fix bónusza', 'research.rp.tip.survey': 'Felmérésekből származó egyszeri adat (már jóváírva)',

  'research.sci.title': 'Tudósok ({count}/{capacity})',
  'research.sci.disabled': 'A tudósok rendszere jelenleg ki van kapcsolva.',
  'research.sci.intro': 'A területek vezető tudósa a terület kutatási pontját növeli, a szakértők a kártyahúzást is befolyásolják. A férőhelyet a laborok adják.',
  'research.sci.upkeep': 'Fenntartás: {value} energia/ó',
  'research.sci.survey': 'Felmérési adat eddig: {value} / {cap} RP',
  'research.sci.empty': 'Még nincs tudósod. Vegyél fel valakit az alábbi jelöltek közül.',
  'research.sci.level': '{level}. szint',
  'research.sci.levelBonus': '{level}. szint · +{bonus} RP',
  'research.sci.specialty': '{area} szakosodás',
  'research.sci.focus': '({theme})',
  'research.sci.xpMax': 'Legmagasabb szint',
  'research.sci.xpNext': '{xp} XP · még {next} a következő szintig',
  'research.sci.upkeepRetire': 'fenntartás {upkeep} en./ó · nyugdíj: {when}',
  'research.sci.assignAria': '{name} beosztása',
  'research.sci.toReserve': '{name} tartalékba került',
  'research.sci.appointed': '{name} a(z) {area} vezetője',
  'research.sci.dismiss': 'Elbocsátás', 'research.sci.dismissed': '{name} elbocsátva',
  'research.sci.candidates': 'Jelöltek', 'research.sci.refresh': 'Az ajánlat megújul: {when}',
  'research.sci.noCandidates': 'Jelenleg nincs szabad jelölt.',
  'research.sci.cost': '{metal} fém · {energy} energia · fenntartás {upkeep} energia/ó',
  'research.sci.hire': 'Felvétel', 'research.sci.hired': 'Felvetted: {name}',
  'research.sci.whyFull': 'Nincs szabad férőhely: építs labort', 'research.sci.whyAfford': 'Nincs elég nyersanyag',
  'research.sci.surveyNote': 'Egy felmért rendszer egyszer ad adatot; a hozam csökken a felmérések számával.',
  'research.sci.xpBar': 'Tapasztalat',
};
